export const locationTypes = {
  CITY: 'city',
  STATION: 'station',
};
